export default "__VITE_ASSET__CI9sc$_1__"